import {CssDimensionRestDto, ImageRoundingRestDto} from "@/api/pharma-cms-content-block/models";
import {CssDimensionRestDtoModel} from "@/models/api/pharma-cms-content-page/CssDimensionRestDtoModel";

export class ImageRoundingRestDtoModel implements ImageRoundingRestDto {
    top_left?: CssDimensionRestDto | null;
    top_right?: CssDimensionRestDto | null;
    bottom_right?: CssDimensionRestDto | null;
    bottom_left?: CssDimensionRestDto | null;

    static createWithDefaults(): ImageRoundingRestDtoModel {
        return new this();
    }

    static cloneFrom(source: ImageRoundingRestDto): ImageRoundingRestDtoModel {
        const clone: ImageRoundingRestDtoModel = new this();

        if (source.top_left) {
            clone.top_left = CssDimensionRestDtoModel.cloneFrom(source.top_left);
        }
        if (source.top_right) {
            clone.top_right = CssDimensionRestDtoModel.cloneFrom(source.top_right);
        }
        if (source.bottom_right) {
            clone.bottom_right = CssDimensionRestDtoModel.cloneFrom(source.bottom_right);
        }
        if (source.bottom_left) {
            clone.bottom_left = CssDimensionRestDtoModel.cloneFrom(source.bottom_left);
        }

        return clone;
    }
}
